import { render, staticRenderFns } from "./trust-order-detail.vue?vue&type=template&id=5ba324c4"
import script from "./trust-order-detail.vue?vue&type=script&lang=js"
export * from "./trust-order-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports